import { keyframes } from '@emotion/react';
import { makeStyles } from 'tss-react/mui';

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const useOfflineMenuItemStyles = makeStyles()((theme) => ({
  item: {
    '&.Mui-disabled': {
      opacity: 1,
      color: theme.palette.text.disabled,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: 'inherit',
      },
    },
  },
  rotating: {
    animation: `${rotate} 1.5s linear infinite`,
  },
  separator: {
    marginInline: theme.spacing(0.5),
  },
  percentage: {
    color: theme.palette.primary.main,
  },
}));
